export default "__VITE_ASSET__DW9S5QhZ__"